// extracted by mini-css-extract-plugin
export default {"noline":"PlanConfig_noline__2nH_9"};